module.exports = __webpack_public_path__ + "static/media/icon_Journal_W.fe4aacae.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_Journal_W.svg
// module id = 1937
// module chunks = 0